module.exports = "<lfwms-searchable-entity-details [serviceFactory]=\"serviceFactory\"></lfwms-searchable-entity-details>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/reports/maintain-report/maintain-report-home/maintain-report-details/maintain-report-details.component.html
// module id = ../../../../../src/app/features/reports/maintain-report/maintain-report-home/maintain-report-details/maintain-report-details.component.html
// module chunks = main